import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const EmailIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({}, attributes, {
    width: size,
    height: size,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    d: "M0.0495838 3.63303C0.251722 2.74245 1.04819 2.07764 1.99994 2.07764H13.9996C14.9513 2.07764 15.7478 2.74245 15.9499 3.63303L7.99974 8.49146L0.0495838 3.63303ZM0 4.77463V11.8779L5.80301 8.32092L0 4.77463ZM6.76118 8.90647L0.191865 12.9332C0.512588 13.6095 1.20164 14.0773 1.99994 14.0773H13.9996C14.7978 14.0773 15.4869 13.6095 15.8076 12.9332L9.2383 8.90647L7.99974 9.66337L6.76118 8.90647ZM10.1965 8.32092L15.9995 11.8779V4.77463L10.1965 8.32092Z",
    fill: color
  }));
};
export default EmailIcon;